import { Progress } from '@base-ui/react/progress'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ProgressIndicatorProps extends PartProps<Progress.Indicator.Props> {
  className?: string
}

function ProgressIndicator({ className, ...props }: ProgressIndicatorProps) {
  return (
    <Progress.Indicator
      className={twMerge(
        'bg-yellow/60 block transition-all duration-500 data-[indeterminate]:animate-pulse',
        className,
      )}
      {...props}
    />
  )
}

export { ProgressIndicator }
